import { useSpring } from "@react-spring/web"
import { Link } from "gatsby"
import React, { useState } from "react"
import { animated } from "react-spring"
import { CollectionProduct } from "../types/ShopifyCollection"

export const ProductCard: React.FC<{ product: CollectionProduct }> = ({
  product,
}) => {
  const [imgIx, setImgIx] = useState(0)
  const styles = useSpring({
    reset: true,
    to: { opacity: 1 },
    from: { opacity: 0.5 },
  })

  const minVariantPrice = Number(
    product.priceRange.minVariantPrice.amount
  ).toFixed(0)
  const maxVariantPrice = Number(
    product.priceRange.maxVariantPrice.amount
  ).toFixed(0)

  return (
    <Link className="block" to={"/objects/" + product.handle}>
      <animated.div
        style={{
          width: "100%",
          paddingTop: "100%",
          backgroundImage: `url("${product.images[imgIx].originalSrc}&width=800&scale=3")`,
          backgroundSize: "125%",
          ...styles,
        }}
        onMouseEnter={() => {
          if (product.images.length > 1) setImgIx(1)
        }}
        onMouseLeave={() => {
          if (product.images.length > 1) setImgIx(0)
        }}
        className="bg-white bg-center bg-cover"
      />
      <div className="my-5 text-center h4-universal">
        {product.title}
        <div className="mt-1">
          {minVariantPrice === maxVariantPrice
            ? `$${minVariantPrice}`
            : `$${minVariantPrice} - $${maxVariantPrice}`}
        </div>
      </div>
    </Link>
  )
}
